import { SVGProps } from 'react';

const Parked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.023 8.333H5.978L3.75 14.75V23H6.5v-1.833h11V23h2.75v-8.25zM7.279 10.167h9.433l.953 2.75H6.325zM6.5 17.042c0-.761.614-1.375 1.375-1.375.76 0 1.375.614 1.375 1.375 0 .76-.614 1.375-1.375 1.375-.76 0-1.375-.615-1.375-1.375m8.25 0c0-.761.614-1.375 1.375-1.375.76 0 1.375.614 1.375 1.375 0 .76-.614 1.375-1.375 1.375-.76 0-1.375-.615-1.375-1.375M12 6.83 9.406 4.245l1.292-1.292L12 4.245 15.245 1l1.293 1.293z"
    />
  </svg>
);
export default Parked;
